export const TYPES_DOCUMENTS = [
  { value: "informe_trimestral", label: "Copia del informe presentado trimestralmente" },
  { value: "asistentes_capacitaciones", label: "Listado unificado de asistentes a las capacitaciones" },
  { value: "evidencias_capacitaciones", label: "Evidencias de las actividades de capacitación adelantadas a los conductores" },
  { value: "colaboradores_organizacion", label: "Listado unificado de los colaboradores de la organización" },
  { value: "informe_lider_pesv", label: "Copia del informe del líder del PESV" }
];

